(function (Drupal, $) {
    Drupal.behaviors.accordionSpacing= {
      attach: function (context) {
        $(".accordions", context)
          .each(function () {
  
            //reduce spacing between the Download and Accordion components when used together

            function reduceSpacing(elementOneSelector, elementTwoClassName) {
              var accordionElements = document.querySelectorAll(elementOneSelector);

              for (var i=0; i < accordionElements.length; i++) {
                var nextSibling = accordionElements[i].nextElementSibling;
                var previousSibling = accordionElements[i].previousElementSibling;

                if (nextSibling && nextSibling.tagName === 'DIV' && nextSibling.classList.contains(elementTwoClassName)) {
                    var accordion =  accordionElements[i].querySelector('.accordions')
                       accordion.classList.remove('margin-v-7')
                       accordion.classList.add('margin-v-3')
                   } 
   
                   if (previousSibling && previousSibling.tagName === 'DIV' && previousSibling.classList.contains(elementTwoClassName)) {
                       var accordion =  accordionElements[i].querySelector('.accordions')
                       accordion.classList.remove('margin-v-7')
                       accordion.classList.add('margin-v-3')
                   } 
              }
            }
  
            reduceSpacing(".paragraph--type--accordion-panel", "paragraph--type--downloads-panel");
          }); 
      },
    };
  })(Drupal, jQuery);
  